import styled from 'styled-components';
import { getTextTokenPreset } from '@optimus-web/common';
import { getEllipticableCss, getTypographyColor, getTypographyOptions } from './helpers';
import { TypographyProps } from './types';

export const Typography = styled.div<TypographyProps>`
    margin: 0;
    ${({ textStyle }) => getTextTokenPreset(textStyle)};
    color: ${getTypographyColor};
    ${getTypographyOptions}
    ${getEllipticableCss}
    text-decoration: ${({ underline, lineThrough }) => {
        const decorators = [];

        if (underline) decorators.push('underline');
        if (lineThrough) decorators.push('line-through');

        return decorators.join(' ');
    }};
`;
